import { isExternalImage } from "@/util/image"

export const base64ImageRegex = /data:image\/([a-zA-Z]*);base64,([^\"]*)/

export const isPlaceholderImage = (src: string) =>
  base64ImageRegex.test(src) || isExternalImage(src)
